(function () {
    'use strict';

    angular
        .module('app')
        .controller('UserExportListController', BadgesListController);

    BadgesListController.$inject = ['API', 'debug', 'helpers', '$stateParams', 'ListViewSearchExtension',];

    function BadgesListController(API, debug, helpers, $stateParams, ListViewSearchExtension) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            sort: 'alphabetDescending',
            gameTag: '',
        };
        vm.loadingState = {
            exports: false,
        };

        vm.now = helpers.getDatabaseDatetime();
        vm.loadResources = loadResources;
        vm.keyUp = keyUp;
        vm.userExports = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }

            loadResources(true);
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'expand': 'school, users',
            };

            if (vm.listObject.filter.sort) {
                switch (vm.listObject.filter.sort) {
                    case 'alphabetAscending':
                        searchObject.sort = '-name';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'name';
                        break;
                    case 'updatedAsscending':
                        searchObject.sort = 'updated';
                        break;
                    case 'updatedDescending':
                        searchObject.sort = '-updated';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.filter.gameTag) {
                searchObject.game_tag = vm.listObject.filter.gameTag;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.UserExport.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.UserExport.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.exports = true;
                promise.then(function (response) {
                    vm.userExports = response.items;
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.exports = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }
    }
})();